package features.booking

data class Notificacion(
    val id: String = "",
    val tipo: String = "",
    val titulo: String = "",
    val mensaje: String = "",
    val timestamp: Long = 0L,
    val leida: Boolean = false,
    val destinatarioRol: String = "",
    val destinatarioUid: String = "",
    val datos: Map<String, String> = emptyMap()
)